import { useEffect, useRef } from "react";
import { isEqual } from "lodash";

export function useDeepCompareEffect(
  callback: React.EffectCallback,
  dependencies: any[],
) {
  const currentDependenciesRef = useRef<any[]>();

  if (!isEqual(currentDependenciesRef.current, dependencies)) {
    currentDependenciesRef.current = dependencies;
  }

  useEffect(callback, [currentDependenciesRef.current]);
}
